module.exports = __webpack_public_path__ + "static/media/linked-account.77926ad3.jpg";